var viewer_figure_default = {
  "figure": "ug0Fb"
};
export {
  viewer_figure_default as default
};
//# sourceMappingURL=viewer-figure-scss.js.map
